/**
 *
 * @module atvFairPlayDrmProvider
 * @see https://github.bamtech.co/sdk-doc/spec-sdk/blob/master/specs/feature_overviews/drm.md
 * @see https://github.bamtech.co/sdk-doc/spec-sdk/blob/master/specs/feature_overviews/drm.md#fairplay
 * @see https://github.bamtech.co/services-commons/mdrm/blob/master/FairPlayStreaming_PG.pdf
 *
 */

import Check from 'check-types';
import Logging from './../logging/entry';
import Services from './../services/entry';
import FairPlayDrmProvider from './fairPlayDrmProvider';
import AtvFairPlayCertificateStorage from './atvFairPlayCertificateStorage';

const Util = Services.Util;

const InvalidArgumentException = Services.Exception.InvalidArgumentException;

const {
    nonEmptyString
} = Check.assert;

/**
 *
 * @class AtvFairPlayDrmProvider
 * @desc FairPlay is the Apple content encryption standard.
 * @since 3.3.3
 *
 */
export default class AtvFairPlayDrmProvider extends FairPlayDrmProvider {

    /**
     *
     * @param {SDK.Drm.DrmManager} provider
     * @param {SDK.Token.TokenManager} tokenManager
     * @param {SDK.Logging.Logger} logger
     *
     */
    constructor(provider, tokenManager, logger = Logging) {

        super(provider, tokenManager, logger);

        /**
         *
         * @access private
         * @type {AtvFairPlayCertificateStorage}
         * @desc references the Storage API to get/set a certificate
         *
         */
        this.certificateStorage = new AtvFairPlayCertificateStorage(
            Util.getSafe(() => this.provider.clientId),
            Util.getSafe(() => this.provider.environment),
            Util.getSafe(() => this.provider.storage),
            this.logger
        );

        this.logger.log(AtvFairPlayDrmProvider.name, 'Created.');

    }

    /**
     *
     * @access private
     * @param {String} serverPlaybackContext
     * @desc Gets a license required for decrypting FairPlay protected content.
     * @emits {MediaFailure} - Raised when the method fails, describing the cause of the problem.
     * @returns {Promise<Array<Byte>>}
     *
     */
    getFairPlayLicense(serverPlaybackContext) {

        const errorMessage = {
            method: 'AtvFairPlayDrmProvider.getFairPlayLicense(serverPlaybackContext)',
            get serverPlaybackContext() {
                return `${this.method} serverPlaybackContext should be a String with length`;
            }
        };

        nonEmptyString(serverPlaybackContext, errorMessage.serverPlaybackContext, InvalidArgumentException);

        const { provider, logger, failureEvent } = this;

        return provider.getFairPlayLicense(serverPlaybackContext).then((data) => {

            return Promise.resolve(data);

        }).catch((exception) => {

            logger.error(AtvFairPlayDrmProvider.name, 'FairPlay license request failure.');
            logger.info(AtvFairPlayDrmProvider.name, `Dispatch ${failureEvent} event.`);

            this.emit(failureEvent, exception);

            return Promise.reject(exception);

        });

    }

}



// WEBPACK FOOTER //
// ./src/drm/atvFairPlayDrmProvider.js